import * as React from 'react'
import {
  addCommunityCustomEmoji,
  deleteCommunityCustomEmoji,
  getCommunityCustomEmojisCached,
  type CommunityCustomEmoji,
} from '../services/communityCustomEmojiService'

export function useCommunityCustomEmojis() {
  const [emojis, setEmojis] = React.useState<CommunityCustomEmoji[]>([])
  const [loading, setLoading] = React.useState(true)
  const [uploading, setUploading] = React.useState(false)
  const [deletingId, setDeletingId] = React.useState<string | null>(null)
  const [error, setError] = React.useState<string | null>(null)

  const reload = React.useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const list = await getCommunityCustomEmojisCached()
      setEmojis(list)
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('[CommunityCustomEmoji] reload error', err)
      setEmojis([])
      setError('Falha ao carregar emojis personalizados.')
    } finally {
      setLoading(false)
    }
  }, [])

  React.useEffect(() => {
    reload().catch(() => {
      // erro já tratado
    })
  }, [reload])

  const addEmoji = React.useCallback(
    async (file: File) => {
      setUploading(true)
      setError(null)
      const result = await addCommunityCustomEmoji(file)
      if (!result.ok) {
        setUploading(false)
        setError(result.reason)
        return result
      }

      await reload()
      setUploading(false)
      return result
    },
    [reload],
  )

  const deleteEmoji = React.useCallback(
    async (emoji: CommunityCustomEmoji) => {
      const id = String(emoji?.id || '').trim()
      if (!id) return { ok: false as const, reason: 'Emoji inválido.' }

      setDeletingId(id)
      setError(null)
      const result = await deleteCommunityCustomEmoji(emoji)
      if (!result.ok) {
        setDeletingId(null)
        setError(result.reason)
        return result
      }

      await reload()
      setDeletingId(null)
      return result
    },
    [reload],
  )

  return {
    emojis,
    loading,
    uploading,
    deletingId,
    error,
    reload,
    addEmoji,
    deleteEmoji,
  }
}
